"use client";
import React from "react";
import AchievementBadge from "./AchievementBadge";

interface BadgeSectionProps {
  showTitle?: boolean;
}

const BadgeSection: React.FC<BadgeSectionProps> = ({ showTitle = true }) => {
  return (
    <section className="mt-6 w-full">
      {showTitle && (
        <div className="pl-3 w-full text-lg font-semibold leading-loose text-gray-900">
          <h2 className="w-full">
            <div className="flex gap-4 w-full">
              <span className="flex-1 shrink w-full basis-0 min-w-60">
                Your Badges
              </span>
            </div>
          </h2>
        </div>
      )}
      <div className="flex gap-3 mt-6 max-w-full text-xs text-center text-gray-800 bg-black bg-opacity-0 w-[358px]">
        <AchievementBadge
          iconUrl="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/ea91955b794d3ff70f4b4474ff14e3090c916e3f?placeholderIfAbsent=true"
          label="First Save"
          backgroundColor="bg-amber-100"
        />
        <AchievementBadge
          iconUrl="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/2677ba869de8cc58c9d395bcdd877d5b27e0ddc3?placeholderIfAbsent=true"
          label="Water Pro"
          backgroundColor="bg-blue-100"
        />
        <img
          src="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/c89a4ebb1d8f8abf297258d1f92f8d9e7da6d232?placeholderIfAbsent=true"
          alt="Locked badge"
          className="object-contain shrink-0 rounded-xl aspect-square w-[81px]"
        />
        <img
          src="https://cdn.builder.io/api/v1/image/assets/e8fd2a11e5e6412dbddb276a310a5dca/43fef9e8dc10ee6afce7a2d2d8c3c2bf564bc011?placeholderIfAbsent=true"
          alt="Locked badge"
          className="object-contain shrink-0 w-20 aspect-[0.99]"
        />
      </div>
    </section>
  );
};

export default BadgeSection;
